import { Component, inject, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { UsersService } from 'app/back-office/shared/services/back-office/users.service';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { RolesEnum } from 'app/shared/enums/roles.enum';
import { FilterItem, InternalFilterGroup } from 'app/shared/models/filter-group.models';
import { ShopContextStore } from 'app/shared/state/shop-context.store';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

@Component({
    selector: 'app-user-filter',
    templateUrl: './user-filter.component.html',
    styleUrls: ['./user-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserFilterComponent implements OnInit, OnChanges {
  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;

  loaderId = UtilityFunctions.newGuid();
  searchSettings: SearchSettings = {
    placeholder: 'Search name...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [new FilterItem({ text: 'STATUS.ALL', value: null })];

  rolesForFilter: string[] = [];
  currentStoreId: number = null;
  private _shopContext = inject(ShopContextStore);

  constructor(
    private _usersService: UsersService,
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionState && this.accordionState && this.dataToView.length === 1) {
      this.calculateRolesForFilter();
      this.filter.isOnFilterConsiderCurrentStore
        ? this.currentStoreId = this._shopContext.currentShop().id
        : this.currentStoreId = null;
      this.setDataToView(0);
    }
  }

  ngOnInit(): void {
  }

  onSearch(search: string) {
    this.searchValue = search;
    if (search === '') this.dataToView = [new FilterItem({ text: 'STATUS.ALL', value: null })];
    this.setDataToView(0);
  }

  setDataToView(skipCount: number) {
    this._usersService.getAllUsers(this.loaderId, skipCount, 20, null, this.searchValue, this.rolesForFilter, this.currentStoreId).subscribe(res => {
      this.dataToView = res.items.map(el => FilterMapper.UserFilter(el));
      this.totalCount = res.totalCount + 1;
    });
  }

  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount ? skipCount - 1 : skipCount;
      this.setDataToView(next);
    }
  }

  private calculateRolesForFilter() {
    this.filter.userFiltersByRoles?.forEach(role => {
      const roleName = RolesEnum[role];
      if (roleName && !this.rolesForFilter.includes(roleName)) {
        this.rolesForFilter.push(roleName);
      }
    });
  }

}
